import type {
  FileEditorDescription,
  ValueConfig_V,
} from "@smartsuite/automation-engine-api";

import { t } from "i18next";

const getTotalSize = (files: Array<ValueConfig_V["value"]>): number => {
  return files.reduce((acc, value) => {
    if (value.oneofKind === "file") {
      const fileSize = value.file.metadata?.size ?? 0;

      return acc + fileSize;
    }

    return acc;
  }, 0);
};

const megabyteToBytes = (megabytes: number | undefined): number => {
  if (megabytes === undefined) return 0;

  return megabytes * 1024 * 1024;
};

export const validateAttachmentsInput = (
  files: ValueConfig_V[],
  fileConfig: FileEditorDescription,
): string => {
  const fileValues = files.map((file) => file.value);
  const totalSize = getTotalSize(fileValues);
  const maximumUploadSize = fileConfig.maximumUploadSize;

  if (maximumUploadSize === undefined) {
    return "";
  }

  if (totalSize > megabyteToBytes(maximumUploadSize)) {
    return t("automation-form.attachment-validation-error", {
      maximumUploadSize: String(maximumUploadSize),
    });
  }

  return "";
};
